import { BaseView } from "~/components";
import BannerSection from "./components/Banner";
import PartnerSection from "./components/Partner";
import BlogSection from "./components/Blog";
import OpacitySection from "./components/Opacity";
import VideoSection from "./components/Video";
const HomeView = () => {
  return (
    <>
      <BaseView>
        <BannerSection />
        <OpacitySection />
        <PartnerSection />
        <VideoSection />
        <BlogSection />
      </BaseView>
    </>
  );
};

export default HomeView;
